import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleGroupActivityEventHydration } from './vehicle-group-activity-event-hydration.dto';

/**
 * A vehicle group activity event with hydrated related records.
 */
export class VehicleGroupActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleGroupActivityEventHydration;
}
